import {Injectable} from '@angular/core';
import {Feature, Overlay} from 'ol';
import {EventsKey} from 'ol/events';
import olMap from 'ol/Map';
import {CoordinatePointModel} from '../models/coordinate-point';
import {FeatureType} from '../models/EnumTypes';
import {MapService} from './map.service';
import {unByKey} from 'ol/Observable';
import {NavaidModel} from '../models/navaid';
import {PointsService} from './points.service';
import {ProcedureModel} from '../models/procedure';
import {AirSpaceBoundaryModel} from '../models/air-space-boundary';
import {FligthInspectionDataModel} from '../models/FlightInspectionDataModel';
import {GritFeature} from "../models/grit/grit.feature";
import Circle from "ol/geom/Circle";
import {Pixel} from "ol/pixel";
import * as olExtent from "ol/extent";
import { toLonLat } from 'ol/proj';
import {Coordinate, toStringHDMS} from 'ol/coordinate.js';
import { MultiPoint } from 'ol/geom';
import { EventListenersOnMap } from '../utils/eventListenersOnMap';

@Injectable({
  providedIn: 'root'
})
export class IdentifyToolService {

  map: olMap
  eventKey: EventsKey;
  container = null;
  content = null;
  closer = null;
  overlay = null;
  pointServiceAux: PointsService;
  

  static readonly EVENT_ON_MAP_LABEL: string = "Identify Tool";

  constructor(private mapService : MapService, public pointService : PointsService) {
    this.map = this.mapService.getMap("map");
    this.pointServiceAux = pointService;
   }


  activateTool(){
    this.createDblClickEvent();
  }

  createDblClickEvent(){
    let thisComponent = this;
    this.container = document.getElementById('popup');
    this.container.onmousemove = function(e) {
      e.stopPropagation();
    };
    this.closer = document.getElementById('popup-closer');

    this.content = document.getElementById('popup-content');

    this.overlay = new Overlay({
      element: this.container,
      stopEvent: true,
      autoPan: {
        animation: {
          duration: 250
        }
      }
    });

    this.map.addOverlay(this.overlay);

    this.closer.onclick = function () {
      this.overlay.setPosition(undefined);
      this.mapService.identifyToolEnabled = false;
      //this.clearListeners();
      this.closer.blur();
      return false;
    }.bind(this);

    let stringToReturn : string = "";
    let found : boolean = false;
    EventListenersOnMap.addEventListener(IdentifyToolService.EVENT_ON_MAP_LABEL, 'click', function(event){
        let this_aux = this;
        stringToReturn = "";
        const coordinate = event.coordinate;
        let hitTolerance = 5;

        this.map.forEachFeatureAtPixel(
          event.pixel,
          function (feat : Feature) {
            let hit =   false;
            if(feat.get("featureType") == FeatureType.CoordinatePoint) {
              return;
            }

            //#region GRIT
            if (feat.get("featureType") == FeatureType.Radar){
              let pixelCenter = this_aux.map.getPixelFromCoordinate(olExtent.getCenter(feat.getGeometry().getExtent()))
              if (Math.sqrt( (event.pixel[0] - pixelCenter[0])**2 + (event.pixel[1] - pixelCenter[1])**2) > 10){
                return
              }
            }
            //endregion
            if (feat.getGeometry() instanceof MultiPoint) {
              const geometry: MultiPoint = feat.getGeometry() as MultiPoint;
              const nearestPoint = geometry.getClosestPoint(event.coordinate);
              geometry.getCoordinates


              if (nearestPoint) {
                const pointPixel = thisComponent.map.getPixelFromCoordinate(nearestPoint);
                const pixelDistance = Math.sqrt(
                  Math.pow(pointPixel[0] - event.pixel[0], 2) +
                  Math.pow(pointPixel[1] - event.pixel[1], 2)
                );
                if (pixelDistance <= hitTolerance) {
                  const pointFeature = thisComponent.pointServiceAux.getCoordinatePointFeatureFromLayersByCoordinate
                  (
                    nearestPoint,
                    feat.get(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY),
                    feat.get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY)
                  );
                  hit = true;
                  stringToReturn += this_aux.featureInformation(pointFeature);
                }
              }
            }
            found = true;
            stringToReturn += this_aux.featureInformation(feat, coordinate);
          },
          {
            hitTolerance: 5,
          }
        );

        if(stringToReturn != "" && found){
          this.content.innerHTML = '<h2>Info Table</h2>' + stringToReturn;
          this.overlay.setPosition(coordinate);
          this.mapService.identifyToolEnabled = true;
        }

    }.bind(this), true);
  }

  featureInformation(feat : Feature, coordinate : Coordinate) : string{
    let featureInfo = "";
    switch(feat.get('featureType')){
      case FeatureType.Navaid:
        let navaid : NavaidModel = this.pointService.transformFeatureInNavaid(feat);
        featureInfo += navaid.getInformation();
        break;
      case FeatureType.CoordinatePoint:
        let coord_point : CoordinatePointModel = this.pointService.transformFeatureInCoordinatePoint(feat);
        featureInfo += coord_point.getInformation();
        break;
      case FeatureType.Procedure:
        let procedure : ProcedureModel = this.pointService.transformFeatureInProcedure(feat);
        featureInfo += procedure.getInformation();
        break;
      case FeatureType.AirSpaceBoundary:
        let airspaceBoundary : AirSpaceBoundaryModel = this.pointService.transformFeatureInAirspaceBoundary(feat);
        featureInfo += airspaceBoundary.getInformation();
        break;
      case FeatureType.FlightInspection:
        let flightInspectionDataModel : FligthInspectionDataModel = this.pointService.transformFeatureInFlightInspectionDataModel(feat);
        featureInfo += flightInspectionDataModel.getInformation();
        break;
      case FeatureType.ProcessingTool:
        let processingToolDataModel: FligthInspectionDataModel = this.pointService.transformFeatureInProcessingToolDataModel(feat);
        featureInfo += processingToolDataModel.getInformationForProcessingTool();
        break;

      case FeatureType.CumulativeCoverage:
        if(feat.get('ID') != null && feat.get('ID').startsWith('CumulativeCoverage')){
          featureInfo += '<h4 style="font-weight:bold">Cumulative Coverage</h4>';
          featureInfo += feat.get('VALUE') ? "<p>Number of Navaids: " + feat.get('VALUE') + "</p>": null;
          featureInfo += feat.get('ELEVATION') ? "<p>Altitude:"+ feat.get('ELEVATION') + "</p>": null;
          if(feat.get('NAVAIDS') != null){
            featureInfo += feat.get('NAVAIDS') ? "<p>Navaids:</p>": null;
            let navaidsString: string = feat.get('NAVAIDS').substring(1, feat.get('NAVAIDS').length-1);
            let navaidsArrays: string[] = navaidsString.split(',');
            navaidsArrays.forEach((navaidString) => {
              featureInfo += '<p>'+navaidString+'</p>';
            });

          }

        }
      break;
      case FeatureType.PerformanceAvailablePairs:
        featureInfo += '<h4 style="font-weight:bold">Info Table</h4>';
        featureInfo += feat.get('VALUE') ? "<p>Available Pairs: " + feat.get('VALUE') + "</p>": null;
        feat.get('PAIRS').split(' ').forEach((pair:string,i) =>{
          featureInfo += "<p>Pair "+(i+1)+"</p>";
          let pairIds = pair.substring(1,pair.length-1).split(',');
          pairIds.forEach((id:string)=>{
            let navaidFeature = this.pointService.getAllNavaidsFeaturesFromLayers().find(feature=> feature.get('navaidid') == id);
            featureInfo += navaidFeature?"<p> ID: " +id+" Type:"+navaidFeature.get('navaidtype')+"<p>": "<p> ID: " +id+"<p>";
          })
        })
        break;

      //#region GRIT
      case FeatureType.Device:
      case FeatureType.Receiver:
      case FeatureType.Radar:
        featureInfo += (feat as GritFeature<any>).entity.identifyToolOutput();
        break;
      //endregion
    }

    return featureInfo;
  }
}
